import { useTranslation } from 'react-i18next';

import type { EnvelopeStatus } from '@/api/envelopes.api';

const CLASS: Record<EnvelopeStatus, string> = {
  draft:       'bg-gray-100 text-gray-700 border-border',
  // "Sent" and "In progress" are treated as one status (patron) — same look.
  sent:        'bg-warning-bg text-warning border-amber-200',
  in_progress: 'bg-warning-bg text-warning border-amber-200',
  completed:   'bg-success-bg text-success border-emerald-200',
  declined:    'bg-danger-bg text-danger border-red-200',
  expired:     'bg-gray-100 text-gray-700 border-border',
  voided:      'bg-gray-100 text-gray-700 border-border',
};

export function StatusBadge({ status }: { status: EnvelopeStatus }) {
  const { t } = useTranslation();
  return <span className={`badge ${CLASS[status]}`}>{t(`envelope.status_${status}`)}</span>;
}
